
import * as types from '../actions/types';

const INITIAL_STATE = {
    collapsed: true
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.TOGGLE_CHECKOUT_ORDER_MODAL:
              return { collapsed: !state.collapsed};

        case types.COLLAPSE_CHECKOUT_ORDER_MODAL:
              return { collapsed: true };
        
        default:
            return state;
    }
}